import { useEffect, useState } from 'react';

interface FileNameLengthConfig {
  maxLength: number;
  preserveEndChars: number;
}

/**
 * Custom hook that returns dynamic file name truncation parameters based on screen width
 * @returns Object containing maxLength and preserveEndChars for formatFileName utility
 */
const useFileNameLength = (isPopup: boolean = false): FileNameLengthConfig => {
  const getFileNameConfig = (): FileNameLengthConfig => {
    const width = window.innerWidth;

    

    // Mobile (< 576px): Very narrow
    if (isPopup) {
      return { maxLength: 15, preserveEndChars: 3 };
    }

    // Mobile (< 576px): Very narrow
    if (width < 576) {
      return { maxLength: 18, preserveEndChars: 3 };
    }
    // Small tablets (576px - 768px): Narrow
    else if (width < 768) {
      return { maxLength: 30, preserveEndChars: 10 };
    }
    // Tablets (768px - 992px): Medium
    else if (width < 992) {
      return { maxLength: 30, preserveEndChars: 10 };
    }
    // Desktop (992px - 1200px): Wide
    else if (width < 1200) {
      return { maxLength: 35, preserveEndChars: 10 };
    }
    // Large desktop (>= 1200px): Extra wide
    else {
      return { maxLength: 45, preserveEndChars: 10 }; 
    }
  };

  const [config, setConfig] = useState<FileNameLengthConfig>(getFileNameConfig());

  useEffect(() => {
    const handleResize = () => {
      setConfig(getFileNameConfig());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return config;
};

export default useFileNameLength;
